module.exports = fox._r("components/avs-yoti/images/splash_bg.jpg", __webpack_public_path__ + "_/_/_/root/components/avs-yoti/images/splash_bg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/avs-yoti/images/splash_bg.jpg
// module id = 533
// module chunks = 4